import { createAsyncThunk } from "@reduxjs/toolkit";
import { type EducationTopic } from "../../../domain/entities/education-topic";
import { type EducationDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listTopics = createAsyncThunk<
  EducationTopic[],
  string,
  { dispatch: EducationDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_TOPICS, async (requestId, { extra }) => {
  return await extra.educationRepo.listTopics(requestId);
});
